let axios = window.axios;
export default {
  // 按客户获取记录
  get_records (customerId) {
    return axios.get('/erp/api.customer_record/index?customer_id=' + customerId)
  },

  // 按创建人获取记录
  get_records_by_staff (params) {
    return axios.get('/erp/api.customer_record/getListByStaff', {
      params: params
    })
  },
  /* 记录类型 */
  get_record_types () {
    return axios.get('/erp/api.customer_record_type/index')
  },

  delete_record (id) {
    return axios.get('/erp/api.customer_record/delete?id=' + id)
  },

  /* 添加客户记录 */
  add_record (params) {
    return axios.post('/erp/api.customer_record/add', params)
  }

}
